// extracted by mini-css-extract-plugin
export default {"price":"style_price__xrhJK"};